module.exports = __webpack_public_path__ + "img/3.01.thmb.xs.2d2d2ccf.jpg";